import { render } from "./courseDetails.vue?vue&type=template&id=6532e717&scoped=true&ts=true"
import script from "./courseDetails.vue?vue&type=script&lang=ts"
export * from "./courseDetails.vue?vue&type=script&lang=ts"

import "./courseDetails.vue?vue&type=style&index=0&id=6532e717&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6532e717"]])

export default __exports__